<template>
  <!--begin::Header-->
  <div id="kt_header" style="" class="header align-items-stretch">
    <!--begin::Brand-->
    <div class="header-brand">
      <div
        class="btn btn-icon btn-circle btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px d-none"
        data-kt-menu-trigger="click"
        data-kt-menu-placement="bottom-end"
      >
        <!--begin::Svg Icon | path: icons/duotune/general/gen025.svg-->
        <span class="svg-icon svg-icon-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor" />
            <rect
              opacity="0.3"
              x="13"
              y="2"
              width="9"
              height="9"
              rx="2"
              fill="currentColor"
            />
            <rect
              opacity="0.3"
              x="13"
              y="13"
              width="9"
              height="9"
              rx="2"
              fill="currentColor"
            />
            <rect
              opacity="0.3"
              x="2"
              y="13"
              width="9"
              height="9"
              rx="2"
              fill="currentColor"
            />
          </svg>
        </span>
        <!--end::Svg Icon-->
      </div>
      <!--begin::Menu-->
      <div
        class="menu menu-sub menu-sub-dropdown menu-column w-150px w-lg-200px"
        data-kt-menu="true"
      >
        <module-switcher />
      </div>
      <!--begin::Logo-->
      <router-link :to="{ name: 'dashboard', params: { module: $module } }">
        <img
          alt="Logo"
          :src="static('metronic/assets/media/logos/roclo-logo.svg')"
          class="h-24px logo"
        />
      </router-link>
      <!--end::Logo-->
      <!--begin::Aside minimize-->
      <div
        id="kt_aside_toggle"
        class="btn btn-icon w-auto px-0 btn-active-color-primary aside-minimize"
        data-kt-toggle="true"
        data-kt-toggle-state="active"
        data-kt-toggle-target="body"
        data-kt-toggle-name="aside-minimize"
      >
        <!--begin::Svg Icon | path: icons/duotune/arrows/arr092.svg-->
        <span class="svg-icon svg-icon-1 me-n1 minimize-default">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect
              opacity="0.3"
              x="8.5"
              y="11"
              width="12"
              height="2"
              rx="1"
              fill="black"
            />
            <path
              d="M10.3687 11.6927L12.1244 10.2297C12.5946 9.83785 12.6268 9.12683 12.194 8.69401C11.8043 8.3043 11.1784 8.28591 10.7664 8.65206L7.84084 11.2526C7.39332 11.6504 7.39332 12.3496 7.84084 12.7474L10.7664 15.3479C11.1784 15.7141 11.8043 15.6957 12.194 15.306C12.6268 14.8732 12.5946 14.1621 12.1244 13.7703L10.3687 12.3073C10.1768 12.1474 10.1768 11.8526 10.3687 11.6927Z"
              fill="black"
            />
            <path
              opacity="0.5"
              d="M16 5V6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5H6C5.44771 5 5 5.44772 5 6V18C5 18.5523 5.44771 19 6 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18V19C16 20.1046 15.1046 21 14 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H14C15.1046 3 16 3.89543 16 5Z"
              fill="black"
            />
          </svg>
        </span>
        <!--end::Svg Icon-->
        <!--begin::Svg Icon | path: icons/duotune/arrows/arr076.svg-->
        <span class="svg-icon svg-icon-1 minimize-active">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect
              opacity="0.3"
              width="12"
              height="2"
              rx="1"
              transform="matrix(-1 0 0 1 15.5 11)"
              fill="black"
            />
            <path
              d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
              fill="black"
            />
            <path
              d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
              fill="#C4C4C4"
            />
          </svg>
        </span>
        <!--end::Svg Icon-->
      </div>
      <!--end::Aside minimize-->
      <!--begin::Aside toggle-->
      <div
        class="d-flex align-items-center d-lg-none ms-n3 me-1"
        title="Show aside menu"
      >
        <div
          class="btn btn-icon btn-active-color-primary w-30px h-30px"
          id="kt_aside_mobile_toggle"
        >
          <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
          <span class="svg-icon svg-icon-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                fill="black"
              />
              <path
                opacity="0.3"
                d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                fill="black"
              />
            </svg>
          </span>
          <!--end::Svg Icon-->
        </div>
      </div>
      <!--end::Aside toggle-->
    </div>
    <!--end::Brand-->
    <div class="toolbar" id="">
      <!--begin::Toolbar-->
      <div
        class="container-fluid py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between"
      >
        <!--begin::Wrapper-->
        <div
          class="d-flex align-items-center justify-content-between flex-lg-grow-1"
        >
          <div></div>
          <!--begin::Navbar-->
          <div class="d-flex align-items-center" id="kt_header_nav">
            <!--begin::Menu wrapper-->
            <div>
              <!--begin::Menu-->
              <div>
                <div class="d-flex align-items-center">
                  <div ref="globalSearch" class="top-search-wrapper">
                    <div class="search-form-wrapper">
                      <form @click="() => searchFormActive = true" @submit.prevent ref="topSearchForm" action="" :class="{'active': searchFormActive}" class="top-search-form">
                        <div
                          class="custom-select-wrapper w-280px"
                          id="search-custom-dropdown"
                        >
                          <span
                            class="current"
                            data-kt-menu-trigger="click"
                            data-kt-menu-placement="bottom-start"
                            data-kt-menu-overflow="true"
                          >
                            {{
                              $_.findGet(
                                searchTypes,
                                (st) => st.id == searchType,
                                "name",
                                ""
                              )
                            }}
                          </span>
                          <div
                              id="searchTypeMenu"
                            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 fw-semibold w-280px py-2"
                            aria-label="Search Categroy Select"
                            data-kt-menu="true"
                          >
                          <span class="navbar-internal-search-text ps-4">Internal Search</span>
                            <div
                              v-for="st in searchTypes.filter((stt) => !stt.ai)"
                              class="navbar-item"
                            >
                              <a
                                href="#"
                                class="menu-link"
                                @click="() => {searchType = st.id; searchTypeChange(st.id)}"
                                data-kt-menu-dismiss="true"
                              >
                                <span class="d-flex align-items-center">
                                  <span class="icon" v-html="st.svg"> </span>
                                  <span class="ps-2 create-nav-link fs-base">{{
                                    st.name
                                  }}</span>
                                </span>
                              </a>
                            </div>
                            <span class="navbar-roclo-ai-text ps-4">
                              Global Search(Roclo Universe)
                            </span>
                            <div
                              v-for="st in searchTypes.filter((stt) => stt.ai)"
                              class="navbar-item"
                              data-kt-menu-dismiss="true"
                              @click="() => {searchType = st.id; searchTypeChange(st.id)}"
                            >
                              <span class="d-flex align-items-center">
                                  <!-- <span class="icon" v-html="st.svg"> </span> -->
                                  <img :src="st.svg" width="20px" height="20px">
                                <span class="ps-2 create-nav-link fs-base">{{
                                  st.name
                                }}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <input
                          @input="searchDebounced"
                          v-model="search_keyword"
                          type="text"
                          class="form-control w-300px"
                          id="searchInput"
                          :placeholder="placeholder"
                          @keyup.enter.prevent="onEnterPress"
                          :class="{ 'ai-placeholder': (searchType=='ai_people') }"
                        />

                        <img
                            @click="clearSearch"
                          :src="
                            static(
                              'metronic/assets/media/images/icons/search-white.svg'
                            )
                          "
                          alt="search icon"
                          class="search-icon"
                        />
                        <img
                            @click="clearSearch"
                          :src="
                            static(
                              'metronic/assets/media/images/icons/close.svg'
                            )
                          "
                          alt="search icon"
                          class="close-search"
                        />
                      </form>
                      <!-- add class show to the .search-results-wrapper to make it visible -->
                      <div @click="handleResultClicks" ref="topSearchResults" v-show="searchFormActive && searchCalls && totalResults" class="search-results-wrapper" id="ifSearchResults">
                        <div class="inner-search-result">
                          <template v-if="['everything', 'company','ai_company', 'ai_company_website'].includes(searchType) && company.length">
                            <div class="heading-wrapper">
                              <div class="icon">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  style="stroke-width: 0"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="#E8F1FD"
                                  ></rect>
                                  <path
                                    d="M2 20H4M4 20H14M4 20V6.2002C4 5.08009 4 4.51962 4.21799 4.0918C4.40973 3.71547 4.71547 3.40973 5.0918 3.21799C5.51962 3 6.08009 3 7.2002 3H10.8002C11.9203 3 12.4796 3 12.9074 3.21799C13.2837 3.40973 13.5905 3.71547 13.7822 4.0918C14 4.5192 14 5.07899 14 6.19691V12M14 20H20M14 20V12M20 20H22M20 20V12C20 11.0681 19.9999 10.6024 19.8477 10.2349C19.6447 9.74481 19.2557 9.35523 18.7656 9.15224C18.3981 9 17.9316 9 16.9997 9C16.0679 9 15.6019 9 15.2344 9.15224C14.7443 9.35523 14.3552 9.74481 14.1522 10.2349C14 10.6024 14 11.0681 14 12M7 10H11M7 7H11"
                                    stroke="#374151"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>
                              </div>
                              <h4>Companies</h4>
                            </div>
                            <ul class="links">
                              <li v-for="comp in company" :key="comp.id" @click="handleItemClicks">
                                <div v-if="!comp.company_id">
                                  <router-link :to="{name: 'company_details', params: {id: comp.id, module: $module}}"
                                         class="">
                                    {{ comp.name }}
                                  </router-link>
                                </div>
                                <div v-else class="d-flex justify-content-between">
                                  <a @click="goToOverview(comp)" href="#">
                                    <span class="text-dark">{{ comp.name }}</span>
                                    <span class="text-muted"> {{(comp.locations.length && comp.locations.some(loc => loc.is_hq)) ? ' | '+ comp.locations.find(loc => loc.is_hq).country_name : (comp.locations.length ? ' | '+ comp.locations[0].country_name : '') }}</span>
                                    <span> {{ ' | '+comp.company_size_on_linkedin +' Employees'}}</span>
             
                                  </a>
                                  <span class="align-self-center">
                                    <button @click="goToOverview(comp)" class="btn btn-sm btn-primary fs-small d-flex gap-1 px-3">
                                      <!-- <span>View</span> -->
                                      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.5 11L11.5 1M11.5 1H3.5M11.5 1V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                              </li>
                            </ul>
                          </template>

                          <template v-if="['everything', 'project'].includes(searchType) && projects.length">
                            <div class="heading-wrapper style--two">
                              <div class="icon">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 17H15M9 14H15M13.0004 3.00087C12.9048 3 12.7974 3 12.6747 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71547 5.21799 4.0918C5 4.51962 5 5.08009 5 6.2002V17.8002C5 18.9203 5 19.4801 5.21799 19.9079C5.40973 20.2842 5.71547 20.5905 6.0918 20.7822C6.51921 21 7.079 21 8.19694 21L15.8031 21C16.921 21 17.48 21 17.9074 20.7822C18.2837 20.5905 18.5905 20.2842 18.7822 19.9079C19 19.4805 19 18.9215 19 17.8036V9.32568C19 9.20302 18.9999 9.09553 18.999 9M13.0004 3.00087C13.2858 3.00348 13.4657 3.01407 13.6382 3.05547C13.8423 3.10446 14.0379 3.18526 14.2168 3.29492C14.4186 3.41857 14.5918 3.59181 14.9375 3.9375L18.063 7.06298C18.4089 7.40889 18.5809 7.58136 18.7046 7.78319C18.8142 7.96214 18.8953 8.15726 18.9443 8.36133C18.9857 8.53379 18.9964 8.71454 18.999 9M13.0004 3.00087L13 5.80021C13 6.92031 13 7.48015 13.218 7.90797C13.4097 8.2843 13.7155 8.59048 14.0918 8.78223C14.5192 9 15.079 9 16.1969 9H18.999"
                                    stroke="#374151"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>
                              </div>
                              <h4>Projects</h4>
                            </div>
                            <ul class="links">
                              <li v-for="project in projects" :key="project.id" class="" @click="handleItemClicks">
                                <router-link :to="{name: 'project_details', params: {id: project.id}}"
                                           :target="$isProperModule('crm') ? '_blank' : ''"
                                         class="">
                                         {{ project.name }}
                                </router-link>
                              </li>
                            </ul>
                          </template>

                          <template v-if="['everything', 'person','ai_people'].includes(searchType) && peoples.length">
                            <div class="heading-wrapper style--two">
                              <div class="icon">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                <path data-v-7c895d2e="" d="M20 21C20 18.2386 16.4183 16 12 16C7.58172 16 4 18.2386 4 21M12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </div>
                              <h4>People</h4>
                            </div>
                            <ul class="links">
                              <li v-if="searchType == 'ai_people'" class="" @click="handleItemClicks">
                                <table class="table table-bordered g_table">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Company</th>
                                      <th>Country</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="people in peoples" :key="people.id">
                                      <td>
                                        {{people.name}}
                                    </td>
                                    <td>
                                      {{$_.get(people.company,'name')}}
                                    </td>
                                    <td>
                                      {{$_.get(people.company,'country')}}
                                    </td>
                                    <td>
                                      <button @click="showPersonDetails(people)" type="button" class="btn btn-primary fs-small d-flex gap-1 px-3 kt_drawer_ai_person_finder_dismiss_button float-end">
                                        <!-- <span>View</span> -->
                                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.5 11L11.5 1M11.5 1H3.5M11.5 1V9" stroke="white" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              </li>
                              <li v-else v-for="people in peoples" :key="people.id" class="" @click="handleItemClicks">
                                <a href="" @click.prevent="handlePeopleSearch(search_keyword, people.name, $event)">
                                  {{ people.name }} ({{$_.get(people.company,'name')}})
                                </a>
                              </li>
                            </ul>
                          </template>

                          <template v-if="['everything', 'opportunity'].includes(searchType) && opportunities.length">
                            <div class="heading-wrapper style--two">
                              <div class="icon">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                <path d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M17 8L13 12L11 10M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </div>
                              <h4>Opportunities</h4>
                            </div>
                            <ul class="links">
                              <li v-for="opportunity in opportunities" :key="opportunity.id" class="" @click="handleItemClicks">
                                <router-link :to="{name: 'crm_opportunity_details', params: {id: opportunity.id}}"
                                           :target="$isProperModule('project') ? '_blank' : ''">
                                  {{ opportunity.title }}
                              </router-link>
                              </li>
                            </ul>
                          </template>

                        </div>
                      </div>
                      <div
                          ref="topSearchNoResult"
                          v-show="searchFormActive && searchCalls && !totalResults"
                        class="search-results-wrapper"
                        id="ifNoSearchResults"
                      >
                        <div class="no-search-result-wrapper">
                          <img
                            :src="
                              static(
                                'munna/assets/images/icons/search-big.svg'
                              )
                            "
                            alt="img"
                          />
                          <h3 class="title">No Results Found</h3>
                          <p>
                            <div>Refine your query to discover relevant items</div>
                            <div v-show="['company', 'ai_company', 'ai_company_website'].includes(searchType)">
                              <div class="my-1">OR</div>
                              <div><span @click="createCompany" class="cursor-pointer text-primary">Add New Company</span></div>
                            </div>
                          </p>
                          <!--<a href="" class="btn btn-outline-secondary"-->
                          <!--  >View Projects</a-->
                          <!--&gt;-->
                        </div>
                      </div>
                    </div>

                    <div v-if="0" class="create-new-btn-wrapper">
                      <button
                        class="btn btn-icon btn-circle large create-new-btn overlay-toggle"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-start"
                        data-kt-menu-overflow="true"
                      >
                        <svg
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 15H15M15 15H25.5M15 15V25.5M15 15V4.5"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                      <quick-access-menu />
                    </div>

                    <div class="create-new-btn-wrapper">
                      <button
                        class="btn btn-icon btn-circle large create-new-btn overlay-toggle"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-start"
                        data-kt-menu-overflow="true"
                      >
                        <svg
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 15H15M15 15H25.5M15 15V25.5M15 15V4.5"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                      <custom-forms-menu />
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Menu-->
              <!--end::Menu-->
            </div>
            <!--end::Menu wrapper-->
          </div>
          <!--end::Navbar-->
          <!--begin::Topbar-->
          <div class="d-flex align-items-stretch flex-shrink-0">
            <!--begin::Toolbar wrapper-->
            <div class="d-flex align-items-stretch flex-shrink-0">
              <!--begin::Quick links-->
              <div class="d-flex align-items-center ms-1 gap-5">
                <!--begin::Menu wrapper-->
                <div class="dropdown notification-wrapper">
                  <button
                    class="btn btn-icon btn-circle btn-show-border notification-btn navbar-has-notification"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      :src="
                        static(
                          'metronic/assets/media/images/icons/bell-blue.svg'
                        )
                      "
                      alt="bell icon"
                    />
                  </button>
                  <div class="dropdown-menu w-250px">
                    <p class="text-center mt-3">No notifications</p>
                  </div>
                </div>
                <div class="vr-line"></div>
                <!--end::Menu wrapper-->
                <user-account-menu />
              </div>
              <!--end::Quick links-->
            </div>
            <!--end::Toolbar wrapper-->
          </div>
          <!--end::Topbar-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Toolbar-->
    </div>

    <!--begin::View component-->
    <div 
        id="kt_drawer_ai_person_finder"
        class="overflow-visible align-items-start bg-transparent"
        data-kt-drawer="true"
        data-kt-drawer-activate="true" 
        data-kt-drawer-toggle=".kt_drawer_ai_person_finder_dismiss_button" 
        data-kt-drawer-close="#kt_drawer_ai_person_finder_dismiss_close" 
        data-kt-drawer-overlay="false"
        data-kt-drawer-width="{default:'300px', 'md': '800px'}" 
    >
          <div class="p-8 w-100 h-100 bg-white  overflow-auto">
            <!--begin::Dismiss button-->
            <button class="drawer-close-btn-left btn position-absolute top-0 left-0 bg-white px-3 py-3 rounded-0 rounded-start" style="" data-kt-drawer-dismiss="true">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 13L7.00002 7.00002M7.00002 7.00002L1 1M7.00002 7.00002L13 1M7.00002 7.00002L1 13" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <!--end::Dismiss button-->
            <div class="d-flex justify-content-between align-items-start">
              <div class="company-profile d-flex align-items-start gap-4">
                
                <!-- <img :src="detail.profile_pic_url" alt="img" class="flex-shrink-0 w-100 rounded-2" style="max-width: 92px; filter: drop-shadow(0px 5px 25px #00000015);"> -->
                <div>
                  <h2 class="mb-2">{{ detail.name }}</h2>
                  <p class="fw-medium fs-base mb-5">{{ detail.job_title }}</p>
                  <a :href="detail.linkedin_url" target="_blank" class="fw-medium fs-base mb-4 d-flex gap-4 align-items-center">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1526_10337)">
                      <path d="M16.4233 19.659C12.1551 20.1143 7.85062 20.1143 3.58243 19.659C2.75359 19.5714 1.97979 19.2025 1.39003 18.6135C0.800281 18.0246 0.430212 17.2513 0.341522 16.4226C-0.113841 12.1544 -0.113841 7.84989 0.341522 3.5817C0.429049 2.75285 0.798032 1.97905 1.38696 1.3893C1.97588 0.799549 2.74917 0.429479 3.57788 0.340789C7.84608 -0.114573 12.1506 -0.114573 16.4188 0.340789C17.2476 0.428316 18.0214 0.7973 18.6112 1.38623C19.2009 1.97515 19.571 2.74843 19.6597 3.57715C20.1151 7.84534 20.1151 12.1499 19.6597 16.4181C19.5722 17.2469 19.2032 18.0207 18.6143 18.6105C18.0253 19.2002 17.2521 19.5703 16.4233 19.659Z" fill="#0B66C3"/>
                      <path d="M7.20597 5.45455C7.20597 5.79167 7.106 6.12123 6.9187 6.40154C6.7314 6.68185 6.46519 6.90033 6.15372 7.02934C5.84226 7.15835 5.49953 7.19211 5.16888 7.12634C4.83823 7.06057 4.53451 6.89823 4.29613 6.65984C4.05774 6.42146 3.8954 6.11773 3.82963 5.78709C3.76386 5.45644 3.79761 5.11371 3.92663 4.80224C4.05564 4.49078 4.27412 4.22457 4.55443 4.03727C4.83474 3.84997 5.16429 3.75 5.50142 3.75C5.95349 3.75 6.38705 3.92959 6.70672 4.24925C7.02638 4.56891 7.20597 5.00247 7.20597 5.45455Z" fill="white"/>
                      <path d="M6.81865 8.29553V15.8262C6.81894 15.8818 6.80826 15.9368 6.78721 15.9882C6.76616 16.0397 6.73515 16.0864 6.69597 16.1258C6.65679 16.1652 6.61022 16.1964 6.55892 16.2178C6.50762 16.2391 6.45261 16.2501 6.39705 16.2501H4.60046C4.54491 16.2502 4.48987 16.2394 4.43852 16.2182C4.38716 16.197 4.3405 16.1659 4.30122 16.1266C4.26193 16.0873 4.2308 16.0407 4.20961 15.9893C4.18842 15.9379 4.17759 15.8829 4.17774 15.8273V8.29553C4.17774 8.18342 4.22227 8.07589 4.30155 7.99662C4.38083 7.91734 4.48835 7.8728 4.60046 7.8728H6.39705C6.50897 7.8731 6.6162 7.91777 6.69523 7.99702C6.77426 8.07626 6.81865 8.18361 6.81865 8.29553Z" fill="white"/>
                      <path d="M16.2109 12.216V15.8614C16.2111 15.9125 16.2011 15.9631 16.1816 16.0103C16.1621 16.0576 16.1335 16.1005 16.0974 16.1366C16.0613 16.1727 16.0184 16.2013 15.9712 16.2208C15.9239 16.2403 15.8733 16.2502 15.8223 16.2501H13.8904C13.8394 16.2502 13.7888 16.2403 13.7415 16.2208C13.6943 16.2013 13.6514 16.1727 13.6153 16.1366C13.5792 16.1005 13.5506 16.0576 13.5311 16.0103C13.5116 15.9631 13.5017 15.9125 13.5018 15.8614V12.3285C13.5018 11.8012 13.6564 10.0194 12.1234 10.0194C10.9359 10.0194 10.6939 11.2387 10.6461 11.7864V15.8614C10.6461 15.9635 10.606 16.0615 10.5343 16.1343C10.4627 16.207 10.3653 16.2486 10.2632 16.2501H8.39727C8.34628 16.2501 8.2958 16.24 8.24871 16.2205C8.20163 16.2009 8.15886 16.1723 8.12286 16.1362C8.08686 16.1001 8.05834 16.0572 8.03894 16.0101C8.01953 15.9629 8.00962 15.9124 8.00977 15.8614V8.26258C8.00962 8.21159 8.01953 8.16108 8.03894 8.11394C8.05834 8.06679 8.08686 8.02394 8.12286 7.98784C8.15886 7.95173 8.20163 7.92309 8.24871 7.90354C8.2958 7.884 8.34628 7.87394 8.39727 7.87394H10.2632C10.3662 7.87394 10.4651 7.91488 10.538 7.98777C10.6109 8.06065 10.6518 8.1595 10.6518 8.26258V8.91939C11.0927 8.25803 11.7461 7.7478 13.1404 7.7478C16.2291 7.7478 16.2109 10.6319 16.2109 12.216Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1526_10337">
                      <rect width="20" height="20" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                      <span>{{ detail.name}}</span>
                  </a>
                  <p class="fw-medium fs-base mb-4 d-flex gap-4 align-items-center">
                    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 18H3M3 18H13M3 18V4.2002C3 3.08009 3 2.51962 3.21799 2.0918C3.40973 1.71547 3.71547 1.40973 4.0918 1.21799C4.51962 1 5.08009 1 6.2002 1H9.8002C10.9203 1 11.4796 1 11.9074 1.21799C12.2837 1.40973 12.5905 1.71547 12.7822 2.0918C13 2.5192 13 3.07899 13 4.19691V10M13 18H19M13 18V10M19 18H21M19 18V10C19 9.06812 18.9999 8.60241 18.8477 8.23486C18.6447 7.74481 18.2557 7.35523 17.7656 7.15224C17.3981 7 16.9316 7 15.9997 7C15.0679 7 14.6019 7 14.2344 7.15224C13.7443 7.35523 13.3552 7.74481 13.1522 8.23486C13 8.60241 13 9.06812 13 10M6 8H10M6 5H10" stroke="#99A1B7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <router-link :to="{name: 'company_details', params: {id: $_.get(detail.company, 'id'), module: $module}}">
                      <span>{{ $_.get(detail.company, 'name')}}</span>
                    </router-link>
                    <!-- <span>{{ $_.get(detail.company, 'name')}}</span> -->
                  </p>
                  
                  <div>
                    <div class="fw-medium fs-base mb-4 d-flex gap-4 align-items-center">
                      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 2L8.10764 6.61227L8.10967 6.61396C8.78785 7.11128 9.12714 7.3601 9.49876 7.45621C9.82723 7.54117 10.1725 7.54117 10.501 7.45621C10.8729 7.36001 11.2132 7.11047 11.8926 6.61227C11.8926 6.61227 15.8101 3.60594 18 2M1 11.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4796 1 17.9074 1.21799C18.2837 1.40973 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.07899 19 4.19691V11.8036C19 12.9215 19 13.4805 18.7822 13.9079C18.5905 14.2842 18.2837 14.5905 17.9074 14.7822C17.48 15 16.921 15 15.8031 15H4.19691C3.07899 15 2.5192 15 2.0918 14.7822C1.71547 14.5905 1.40973 14.2842 1.21799 13.9079C1 13.4801 1 12.9203 1 11.8002Z" stroke="#99A1B7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="d-flex flex-wrap gap-3">
                        <span v-for="(email, indx) in detail.email_json">
                          <a :href="`mailto:`+email">{{email}}</a>
                          {{
                            indx + 1 === (detail.email_json).length ? '' : ', '
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="fw-medium fs-base mb-4 d-flex gap-4 align-items-center">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                      <path d="M7.50246 2.25722C7.19873 1.4979 6.46332 1 5.64551 1H2.89474C1.8483 1 1 1.8481 1 2.89453C1 11.7892 8.21078 19 17.1055 19C18.1519 19 19 18.1516 19 17.1052L19.0005 14.354C19.0005 13.5361 18.5027 12.8009 17.7434 12.4971L15.1069 11.4429C14.4249 11.1701 13.6483 11.2929 13.0839 11.7632L12.4035 12.3307C11.6089 12.9929 10.4396 12.9402 9.7082 12.2088L7.79222 10.2911C7.06079 9.55962 7.00673 8.39134 7.66895 7.59668L8.23633 6.9163C8.70661 6.35195 8.83049 5.57516 8.55766 4.89309L7.50246 2.25722Z" stroke="#99A1B7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      <div class="d-flex flex-wrap gap-3">
                        <span v-for="(phone, indx) in detail.phone_json">{{phone}}{{
                          indx + 1 === (detail.phone_json).length ? '' : ', '
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3 class="py-4 border-bottom border-default mt-5">Other Informations:</h3>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Email :</span> {{ detail.email }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Phone :</span> {{ detail.direct_phone }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Previous Job Title :</span> {{ detail.prev_job_title }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Assistant Name :</span> {{ detail.assistant_name }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Joined date :</span> {{ momentMixin(detail.date_joined) }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Left date :</span> {{ momentMixin(detail.date_left) }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">DNC :</span> {{ detail.dnc ? 'Yes' : 'No' }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Withdrawn :</span> {{ detail.withdrawn ? 'Yes' : 'No' }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Job Tracker :</span> {{ detail.tracker ? 'Yes' : 'No' }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Job Tracker Date :</span> {{ momentMixin(detail.tracker_date) }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Office :</span> {{ detail.office }}</p>
            <p class="fw-medium fs-base mb-3"><span class="fw-bold">Relationship :</span> 
                        <span class="ps-1" v-for="(user, indx) in detail.users">{{user.name}}{{
                          indx + 1 === (detail.users).length ? '' : ', '
                        }}</span>
            </p>

            <h3 class="py-4 border-bottom border-default mt-5">History:</h3>
            
            <div class="d-flex flex-column gap-3">
              <div v-for="history in detail.experience" class="d-flex align-items-center justify-content-between py-2">
                <div class="d-flex gap-5 align-items-center">
                  <div>
                    <content-placeholders v-if="logo_loading">
                      <content-placeholders-text :lines="2"/>
                    </content-placeholders>
                    <img v-else-if="!logo_loading" :src="company_logos[history.company_linkedin_profile_url] || static('metronic/assets/media/avatars/blank.png')" alt="logo" width="36">
                  </div>
                  
                  <div>
                    <h4 class="fw-medium fs-base">{{history.company}}</h4>
                    <p class="fs-small mb-0">{{history.title}}</p>
                  </div>
                </div>
                <p class="mb-0 fs-small text-heading-two">
                  {{ isValidDate(history.starts_at) ? momentMixin(history.starts_at) : history.starts_at}} -
                  {{ isValidDate(history.ends_at) ? momentMixin(history.ends_at) : history.ends_at}}
                </p>
              </div>
            </div>

          </div>
        
    </div>
    <!--end::View component-->
  </div>
  <!--end::Header-->
  
</template>

<style scoped>
input.ai-placeholder::placeholder {
    font-size: 10px;
}

.g_table tbody tr td {
  font-size: 12px;
  padding: 3px;
}

.navbar-internal-search-text {
    font-weight: 500;
    margin-top: 10px;
    font-size: 18px;
    cursor: auto;
    color: var(--c-base) !important;
    padding-bottom: 10px !important;
}
.navbar-roclo-ai-text{
  font-size: 15px !important;
}
</style>

<script>
import UserAccountMenu from "@cc/split/UserAccountMenu.vue";
import SearchGlobalModal from "@cc/GlobalSearch.vue";
import QuickAccessMenu from "@cc/split/QuickAccessMenu.vue";
import CustomFormsMenu from "@cc/split/CustomFormsMenu.vue";
import ModuleSwitcher from "@cc/ModuleSwitcher.vue";
import CompanyOverviewForElse from "@cc/clients/companies/CompanyOverviewForElse.vue";
import default_form_opener from "@cc/modules/crm/custom-forms/default_form_opener";

export default {
  components: {
    UserAccountMenu,
    SearchGlobalModal,
    QuickAccessMenu,
    CustomFormsMenu,
    ModuleSwitcher
  },
  mixins: [default_form_opener],
  data() {
    return {
      searchType: "everything",
      searchTypes: [
        {
          id: "everything",
          name: "Everything",
          svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M17 12C17 12.5523 17.4477 13 18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M5 12C5 12.5523 5.44772 13 6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>`,
        },
        {
          id: "company",
          name: "Company",
          svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 20H4M4 20H14M4 20V6.2002C4 5.08009 4 4.51962 4.21799 4.0918C4.40973 3.71547 4.71547 3.40973 5.0918 3.21799C5.51962 3 6.08009 3 7.2002 3H10.8002C11.9203 3 12.4796 3 12.9074 3.21799C13.2837 3.40973 13.5905 3.71547 13.7822 4.0918C14 4.5192 14 5.07899 14 6.19691V12M14 20H20M14 20V12M20 20H22M20 20V12C20 11.0681 19.9999 10.6024 19.8477 10.2349C19.6447 9.74481 19.2557 9.35523 18.7656 9.15224C18.3981 9 17.9316 9 16.9997 9C16.0679 9 15.6019 9 15.2344 9.15224C14.7443 9.35523 14.3552 9.74481 14.1522 10.2349C14 10.6024 14 11.0681 14 12M7 10H11M7 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>`,
        },
        {
          id: "person",
          name: "Person",
          svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 21C20 18.2386 16.4183 16 12 16C7.58172 16 4 18.2386 4 21M12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>`,
        },
        {
          id: "project",
          name: "Project",
          svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 17H15M9 14H15M13.0004 3.00087C12.9048 3 12.7974 3 12.6747 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71547 5.21799 4.0918C5 4.51962 5 5.08009 5 6.2002V17.8002C5 18.9203 5 19.4801 5.21799 19.9079C5.40973 20.2842 5.71547 20.5905 6.0918 20.7822C6.51921 21 7.079 21 8.19694 21L15.8031 21C16.921 21 17.48 21 17.9074 20.7822C18.2837 20.5905 18.5905 20.2842 18.7822 19.9079C19 19.4805 19 18.9215 19 17.8036V9.32568C19 9.20302 18.9999 9.09553 18.999 9M13.0004 3.00087C13.2858 3.00348 13.4657 3.01407 13.6382 3.05547C13.8423 3.10446 14.0379 3.18526 14.2168 3.29492C14.4186 3.41857 14.5918 3.59181 14.9375 3.9375L18.063 7.06298C18.4089 7.40889 18.5809 7.58136 18.7046 7.78319C18.8142 7.96214 18.8953 8.15726 18.9443 8.36133C18.9857 8.53379 18.9964 8.71454 18.999 9M13.0004 3.00087L13 5.80021C13 6.92031 13 7.48015 13.218 7.90797C13.4097 8.2843 13.7155 8.59048 14.0918 8.78223C14.5192 9 15.079 9 16.1969 9H18.999" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>`,
        },
        {
          id: "opportunity",
          name: "Opportunity",
          svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M17 8L13 12L11 10M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>`,
        },
        { 
          id: "ai_people", 
          name: "Search People", 
          ai: true,
          svg: this.static('munna/assets/icons/users.svg'),
        },
        { 
          id: "ai_company", 
          name: "Search Companies (By Name)",
          ai: true,
          svg:this.static('munna/assets/icons/building.svg'),
        },
        {
          id: "ai_company_website",
          name: "Search Companies (By URL)",
          ai: true,
          svg:this.static('munna/assets/icons/building.svg'),
        },
      ],
      search: {
        global_search: "",
        expanded: false,
      },
      search_keyword: "",
      original_search_keyword: "",
      projects: [],
      company: [],
      opportunities: [],
      peoples: [],
      routes: {
        authorization: [
          { route: "groups", name: "Groups" },
          { route: "permissions", name: "Permissions" },
        ],
        presets: [
          { route: "own/ownership", name: "Ownerships" },
          { route: "own/departments", name: "Departments" },
          { route: "currencies", name: "Currencies" },
          { route: "sc/company_type", name: "Company Type" },
          { route: "sc/sector", name: "Sector" },
          { route: "sc/corporate_status", name: "Corporate Status" },
          { route: "sc/source_type", name: "Source Type" },
          { route: "sc/trading_status", name: "Trading Status" },
          { route: "sc/project_status", name: "Project Status" },
          { route: "sc/user_title", name: "User Title" },
          { route: "sc/transaction_type", name: "Transaction Type" },
          { route: "ps/project_stage", name: "Project Stages" },
          { route: "ps/buyer_stage", name: "Buyer Stages" },
        ],
      },
      gl_show: "",
      gl_style: "",
      expanded: false,
      searchCalls: 0,
      totalResults: 0,
      searchFormActive: false,
      placeholder:'Start Typing to Search',
      company_db:false,

      detail:{},
      company_logos : {},
      logo_loading: false,
      drawer: null,
    };
  },
  created() {
    const allowedTypes = ['everything', 'opportunity', 'company', 'project', 'person'];

    this.searchDebounced = _.debounce(() => {
      if (allowedTypes.includes(this.searchType)) {
        this.fetchGlobalSearch();
      }
    }, this.SEARCH_DEBOUNCE_MS);
    // this.searchDebounced = _.debounce(
    //   () => this.fetchGlobalSearch(),
    //   this.SEARCH_DEBOUNCE_MS
    // );
  },
  mounted() {
    document.body.addEventListener("click", this.clickOutsideSearchBox);

    this.$nextTick(() => {
      // this.initSearchBarListnr();
    });
    setTimeout(() => {
      KTDrawer.createInstances();
      this.drawer = KTDrawer.getInstance(document.querySelector("#kt_drawer_ai_person_finder"));
    }, 1000)

  },
  destroyed() {
    document.body.removeEventListener("click", this.clickOutsideSearchBox);
  },
  computed: {
    truncated_search_keyword() {
      return this.search_keyword.length > 15
        ? this.search_keyword.slice(0, 15) + "..."
        : this.search_keyword;
    },
    getInitials() {
      const name = this.$user.name;

      let parts = name.split(" ");
      let initials = "";
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== "") {
          initials += parts[i][0];
        }
      }
      return initials;
    },
    // Truncate search keyword if it exceeds 10 characters
  },
  methods: {
    createCompany(){
      this.searchFormActive = false
      this.fetchDefaultWriteForm('company', {openNow: true})
    },
    onEnterPress(){
      console.log('heare')
      if(this.searchType == 'ai_people' || this.searchType == 'ai_company' || this.searchType == 'ai_company_website'){
        this.fetchGlobalSearch();
      }
    },
    searchTypeChange(type){
      console.log(type)
      if(['everything', 'opportunity','company','project','person'].includes(type)){
        this.placeholder = 'Start Typing to Search'
      }else if(type == 'ai_people'){
        this.placeholder = 'Enter First Name/Last name followed by #Company Name'
      }else if(type == 'ai_company'){
        this.placeholder = 'Enter Company Name'
      }else if(type == 'ai_company_website'){
        this.placeholder = 'Enter Company URL'
      }
    },
    handleResultClicks(event){
      // if (event.target.closest(".links")) {
      // more precise
      if(event.target.parentElement?.parentElement?.classList.contains("links")) {
        console.log("RESULT_CLICKED", event.target);
        this.searchFormActive = false
      }
    },
    handleItemClicks(event){
      this.searchFormActive = false
    },
    clearSearch(){
      this.search_keyword = ''
      this.projects = []
      this.peoples = []
      this.company = []
      this.opportunities = []
      this.totalResults = 0
    },
    initSearchBarListnr() {
      const searchInput = document.querySelector("#searchInput");
      const searchResult = document.querySelector("#ifSearchResults");
      const noSearchResults = document.querySelector("#ifNoSearchResults");
      const closeSearch = document.querySelector(".close-search");
      // const customDropdown = document.querySelector('#search-custom-dropdown');

      closeSearch.addEventListener("click", function () {
        searchInput.value = "";
        document.querySelector(".overlay").classList.remove("active");
      });

      document.addEventListener("click", function () {
        if (!searchInput.value) {
          searchResult.style.display = "none";
          noSearchResults.style.display = "none";
        }
        if (
          document
            .querySelector(".top-search-form")
            .classList.contains("active")
        ) {
          document.querySelector(".top-search-form").classList.remove("active");
        }
        if (searchInput.value) {
          document.querySelector(".overlay").classList.add("active");
          document.querySelector(".top-search-form").classList.add("active");
        }
      });

      searchInput.addEventListener("click", function (e) {
        e.stopPropagation();
        document.querySelector(".top-search-form").classList.add("active");
        document.querySelector(".overlay").classList.add("active");
      });

      // customDropdown.addEventListener('click', function (e) {
      //   e.stopPropagation()
      //   document.querySelector('.top-search-form').classList.add('active')
      //   document.querySelector('.overlay').classList.add('active')
      // })

      searchInput.addEventListener("keyup", function () {
        if (searchInput.value.trim()) {
          // Ensure input is not just whitespace
          setTimeout(() => {
            searchResult.style.display = "block";
            noSearchResults.style.display = "none";
          }, 300);
        } else {
          setTimeout(() => {
            searchResult.style.display = "none";
            noSearchResults.style.display = "block";
          }, 200);
        }
      });

      document.addEventListener("DOMContentLoaded", () => {
        return;
        // Function to initialize custom select
        const initCustomSelect = (wrapper) => {
          const current = wrapper.querySelector(".current");
          const dropdown = wrapper.querySelector(".custom-select");
          const options = dropdown.querySelectorAll("li");

          // Toggle dropdown visibility
          current.addEventListener("click", () => {
            // Close all other dropdowns
            document
              .querySelectorAll(".custom-select")
              .forEach((otherDropdown) => {
                if (otherDropdown !== dropdown) {
                  otherDropdown.hidden = true;
                  dropdown.classList.add("active");
                }
              });
            dropdown.hidden = !dropdown.hidden;
            dropdown.classList.toggle("active");
          });

          // Handle option selection
          options.forEach((option) => {
            option.addEventListener("click", () => {
              if (option.classList.contains("disabled")) return; // Skip disabled items

              // Update current value
              current.textContent = option.textContent;
              current.dataset.value = option.dataset.value;

              // Update selected class
              options.forEach((opt) => opt.classList.remove("selected"));
              option.classList.add("selected");

              // Close dropdown
              dropdown.hidden = true;
              dropdown.classList.remove("active");
            });
          });
        };

        // Close dropdowns when clicking outside
        document.addEventListener("click", (event) => {
          document.querySelectorAll(".custom-select").forEach((dropdown) => {
            if (
              !dropdown.closest(".custom-select-wrapper").contains(event.target)
            ) {
              dropdown.hidden = true;
              dropdown.classList.remove("active");
            }
          });
        });

        // Initialize all custom select elements
        document
          .querySelectorAll(".custom-select-wrapper")
          .forEach(initCustomSelect);
      });
    },
    clearBox(e) {
      this.search_keyword = "";
      this.projects = "";
      this.company = "";
      this.opportunities = "";
      this.peoples = "";
    },
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    openLinkInNewTab(href) {
      window.open(href, "_blank");
    },

    clickOutsideSearchBox(event) {
      // Check if the clicked element is outside the modal
      // console.log(event)
      // console.log('global: '+this.$refs.globalSearch.contains(event.target))
      if (
        this.$refs.globalSearch &&
        !this.$refs.globalSearch.contains(event.target) &&
          !event.target.closest("#searchTypeMenu")
      ) {
        // Clicked outside the modal, handle accordingly

        // this.showHide("hide");
        this.searchFormActive = false
      }
    },

    showSearchBuyer(modules) {
      this.$modal.show(
        SearchGlobalModal,
        { modules: modules },
        {
          height: "auto",
          scrollable: true,
          top: true,
        }
      );
    },
    cleanWebSite(url) {
      if (!url) return '';
      url = String(url).trim();

      if (url.startsWith('http://')) {
        url = url.slice(7);
      } else if (url.startsWith('https://')) {
        url = url.slice(8);
      }
      if (url.startsWith('www.')) {
        url = url.slice(4);
      }
      if (url.endsWith('/')) {
        url = url.slice(0, -1);
      }

      return url;
    },
    fetchGlobalSearch() {
      console.log(this.searchType)
      this.startCompLoading();
      let keyword = this.cleanWebSite(this.search_keyword)
      this.$axios
        .get(this.getUrl("projects", "projects_global_search"), {
          params: { search: keyword, modules: this.$module , search_type:this.searchType},
        })
        .then(({ data }) => {
          this.endCompLoading();

          console.log(data);
          this.company_db = false
          this.gl_show = "show";
          this.gl_style =
            "{position: absolute;inset: 0px 0px auto auto;margin: 0px;transform: translate(0px, 36px);}";
          this.projects = data.projects;

          if(this.searchType == 'ai_company' || this.searchType == 'ai_company_website'){
            const maxItemsCompany = 15;
            this.company = data.company.slice(0, maxItemsCompany);
          }else{
            this.company = data.company
          }

          this.opportunities = data.opportunities;
          this.peoples = data.peoples;

          let _total = 0
          Object.keys(data).forEach(key => {
              _total += data[key].length
          });
          this.totalResults = _total

          if(['everything', 'opportunity','company','project','person','ai_people'].includes(this.searchType)){
            this.searchCalls++;
          }

          if(this.searchType == 'ai_company' || this.searchType == 'ai_company_website'){
            this.company_db = true

            let search_params = {
              order_employee_size: 1,
              company_size_min: 4
            }
            if(this.searchType === 'ai_company'){
              search_params.company_name_or_website = keyword
            }
            else if(this.searchType === 'ai_company_website'){
              const _url_hostname = tldjs.getDomain(keyword)
              console.info('_url_domain', _url_hostname)
              if(_url_hostname){
                const _domain_no_ext = _url_hostname.split('.')
                console.info(_domain_no_ext, _domain_no_ext)
                if(_domain_no_ext.length){
                  // matches //enzo. | .enzo. JIRA#1522
                  search_params.website = [`//${_domain_no_ext[0]}.`, `.${_domain_no_ext[0]}.`]
                }else{
                  return false
                }
              }else{
                return false
              }
            }
            this.fetchCompany(search_params)
          }
        })
        .catch((err) => {
          this.searchCalls++

          this.toastLaraValidation(err);
          this.endCompLoading();
        }).finally(() => {
        });
    },
    close() {
      console.log("hear");
      this.$emit("close");
    },
    handlePeopleSearch(search, title, event) {
      event.preventDefault();
      localStorage.setItem("global_people_search", title);

      // Navigate manually after performing the search action
      if (this.$module == "crm") {
        this.$router.push({ name: "crm_people", query: { search } });
      } else {
        this.$router.push({ name: "project_people", query: { search } });
      }
    },
    showHide(action = null) {
      if (action == "hide") {
        if (this.expanded) {
          this.original_search_keyword = this.search_keyword;
        }

        // If the keyword length is greater than 15, truncate it
        if (this.search_keyword.length > 15) {
          this.search_keyword = this.truncated_search_keyword;
        }

        // if(this.search_keyword.length > 15 && this.expanded) {
        //   this.original_search_keyword = this.search_keyword;
        //   this.search_keyword = this.truncated_search_keyword;
        // }
        this.gl_show = "";
        this.gl_style = "";
        this.expanded = false;
        return;
      } else if (action == "show") {
        this.expanded = true;
        this.gl_show = "show";
        this.gl_style =
          "{position: absolute;inset: 0px 0px auto auto;margin: 0px;transform: translate(0px, 36px);}";
        if (this.original_search_keyword && this.expanded) {
          this.search_keyword = this.original_search_keyword;
        }
        return;
      }
      
      // if(this.gl_show == ''){
      //   this.expanded = true;
      //   this.gl_show = 'show'
      //   this.gl_style = "{position: absolute;inset: 0px 0px auto auto;margin: 0px;transform: translate(0px, 36px);}"
      // }else{
      //   this.gl_show = ''
      //   this.gl_style = ""
      //   this.expanded = false
      // }
    },
    fetchCompany(params){
      this.startCompLoading();
      axios.get(this.genUrl('companies', null, 'company_finder'),{params, paramsSerializer: {indexes: null}})
          .then(({data}) => {
            const maxItems = 15;
            data.results = data.results.slice(0, maxItems);
            this.company.push(...data.results)

            this.totalResults += data.results.length
          })
          .catch(err => console.error(err))
          .finally(() => {
            this.searchCalls++;
            this.endCompLoading();
          });
    },
    goToOverview(comp) {
      // event.preventDefault()
      // console.log(comp)
      localStorage.setItem('overview_record', JSON.stringify(comp));
      const url = this.$router.resolve({ name: 'company_overview_for_else', params: {module: this.$module} }).href;
      console.log('to_url_blank', url)
      window.open(url, '_blank');
      // this.$modal.show(CompanyOverviewForElse,
      //       {
      //         title: 'Overview',
      //         record: comp
      //       },
      //       {height: "auto",width: "90%", scrollable: true},
      //   );
    },
    showPersonDetails(people){
      console.log(people)
      this.startCompLoading();
      axios.get(this.genUrl('contact', people.id, 'post'))
        .then(({data}) => {
          console.log(data)
          this.detail = data

          this.fetchCompanyLogo(this.detail.experience)
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.endCompLoading();
        });
    },
    isValidDate(date) {
      return !isNaN(Date.parse(date));
    },
    async fetchCompanyLogo(experience){
      this.company_logos = {}
      this.logo_loading = true
      for (const history of experience) {
        const company_url = history.company_linkedin_profile_url;
        if (company_url && !this.company_logos[company_url]) {
          const cleanUrl = company_url.endsWith('/') ? company_url.slice(0, -1) : company_url;
          const parts = cleanUrl.split('/');
          const linkedin = parts[parts.length - 1];
          // console.log(linkedin)
          const params = {
            mode: 'logo',
            linkedin_id: linkedin,
          }
          try {
            const response = await axios.get(this.genUrl('companies', null, 'company_finder'), {params});
            this.company_logos[company_url] = response.data.pic_url;
          } catch (err) {
            console.error('Error fetching company logo:', err);
            this.company_logos[company_url] = '';
          }
        }
      }
      
      this.logo_loading = false
      
    },

    
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  /* Hide the logo when the search bar is expanded */
  .d-none {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
}
</style>
